<div class="flex flex-column gap-2 h-full" [ngClass]="{ loadingContainer: loading(), nonLoadingContainer: loading() }">
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex h-full justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    <div class="flex w-full justify-content-between">
      <span class="statisticTitle">{{ "gate_fault_frequency_widget.title" | translate }}</span>
      <div style="align-self: flex-start">
        <app-button (click)="op.toggle($event)" [buttonText]="buttonText"></app-button>

        <p-popover #op>
          <div class="flex flex-column gap-3 p-4">
            <div class="flex gap-3 align-items-end">
              <div class="flex align-items-center">
                <p-radioButton name="date" value="date" [(ngModel)]="periodOption" inputId="date" />
                <label for="date" class="ml-2">
                  {{ "temperature_chart_widget.period" | translate }}
                </label>
              </div>
              @if (periodOption === "date") {
                <div class="flex flex-column gap-1">
                  <label for="selectedStartDate">{{ "temperature_chart_widget.start_date" | translate }}</label>
                  <p-datePicker
                    id="selectedStartDate"
                    [(ngModel)]="selectedStartDate"
                    [readonlyInput]="true"
                    dateFormat="dd.mm.yy"
                    appendTo="body"
                  />
                </div>
                <div class="flex flex-column gap-1">
                  <label for="selectedStartDate">{{ "temperature_chart_widget.end_date" | translate }}</label>
                  <p-datePicker
                    [(ngModel)]="selectedEndDate"
                    [readonlyInput]="true"
                    dateFormat="dd.mm.yy"
                    appendTo="body"
                  />
                </div>
              }
            </div>
            <div class="flex align-items-center gap-3">
              <div class="flex">
                <p-radioButton
                  name="quick-selection"
                  value="quick-selection"
                  [(ngModel)]="periodOption"
                  inputId="quick-selection"
                />
                <label for="quick-selection" class="ml-2">
                  {{ "temperature_chart_widget.quick_selection" | translate }}
                </label>
              </div>

              @if (periodOption === "quick-selection") {
                <p-select
                  class="ml-2"
                  [options]="quickSelectionOptions"
                  appendTo="body"
                  [(ngModel)]="selectedQuickSelection"
                >
                  <ng-template #selectedItem>
                    {{ selectedQuickSelection | translate }}
                  </ng-template>
                  <ng-template let-option #item>
                    {{ option | translate }}
                  </ng-template>
                </p-select>
              }
            </div>
            <div class="flex gap-3 justify-content-end">
              <app-button buttonText="common.cancel" color="grey" (click)="op.hide()"></app-button>
              <app-button buttonText="common.adopt" (click)="saveTimeSelection(); op.hide()"> </app-button>
            </div>
          </div>
        </p-popover>
      </div>
    </div>
  }

  <div [ngClass]="{ noHeight: loading() || timeOut() }" class="chartContainer">
    <canvas [id]="chartId()" class="w-full" [ngClass]="{ hide: loading() || timeOut() }"></canvas>
  </div>
</div>
